import {useLocalStorage} from 'platform/components';

import {ReactNode} from 'react';

import {isNotNil} from 'ramda';

// import {useGetRolesQuery} from '@dms/api/customer';
// import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {
  browserStorageKey,
  getWorktreeName,
  hasMandatoryFieldsValidationOverride,
} from '@dms/config';
import i18n from '@dms/i18n';

import {CI_MODE, createContext, useBoolean, useOnMount} from 'shared/web';

// import {DEBUG_ROLE_REFIX} from '../utils/const';

type DeveloperSettingsContext = {
  settings: {
    // isRoleDebuggingEnabled: boolean;
    isTranslationsSettingsEnabled: boolean;
    isContentEditableSettingsEnabled: boolean;
    isMockingFlagsSettingsEnabled: boolean;
    isMandatoryFieldsValidationDisabled: boolean;
    isPerformanceTrackingEnabled: boolean;
    worktreeName: string | null;
    apiTrafficValidation: {
      isValidating: boolean;
      start: () => void;
      stop: () => void;
    };
  };
  isAnyDevSettingEnabled: boolean;
  isOpen: boolean;
  close: () => void;
  open: () => void;
};

const [Provider, useDeveloperSettings] = createContext<DeveloperSettingsContext>({
  name: 'developerSettings',
});

interface DeveloperSettingsProviderProps {
  children: ReactNode;
}

export function DeveloperSettingsProvider(props: DeveloperSettingsProviderProps) {
  const [isOpen, setIsOpen] = useLocalStorage<'closed' | 'open'>(
    browserStorageKey.DEV_SETTINGS_SIDEBAR_STATE,
    'closed'
  );

  const [isPerformanceTrackingEnabled] = useLocalStorage<boolean>(
    browserStorageKey.PERFORMANCE_TRACKING_ENABLED,
    false
  );

  useOnMount(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem(browserStorageKey.DEV_SETTINGS_SIDEBAR_STATE);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
  });

  const [isValidatingApiTraffic, startApiTrafficValidation, stopApiTrafficValidation] =
    useBoolean();

  // const {data: currentUser} = useGetCurrentUserInfoQuery();
  // const {data: roles} = useGetRolesQuery({});

  const isMockingFlagsSettingsEnabled =
    localStorage.getItem(browserStorageKey.MOCK_FLAGS_KEY) !== null;
  const isContentEditableSettingsEnabled = document.body.contentEditable === 'true';
  const isTranslationsSettingsEnabled = i18n.language === CI_MODE;
  const isMandatoryFieldsValidationDisabled = hasMandatoryFieldsValidationOverride();
  const worktreeName = getWorktreeName();
  // const isRoleDebuggingEnabled =
  //   roles?.some((role) => role.title === `${DEBUG_ROLE_REFIX}-${currentUser?.id}`) ?? false;

  const isAnyDevSettingEnabled =
    // isRoleDebuggingEnabled ||
    isTranslationsSettingsEnabled ||
    isContentEditableSettingsEnabled ||
    isMockingFlagsSettingsEnabled ||
    isMandatoryFieldsValidationDisabled ||
    isPerformanceTrackingEnabled ||
    isNotNil(worktreeName);

  const settings: DeveloperSettingsContext['settings'] = {
    isMockingFlagsSettingsEnabled,
    isContentEditableSettingsEnabled,
    isTranslationsSettingsEnabled,
    isMandatoryFieldsValidationDisabled,
    isPerformanceTrackingEnabled,
    worktreeName,
    // isRoleDebuggingEnabled,
    apiTrafficValidation: {
      isValidating: isValidatingApiTraffic,
      start: startApiTrafficValidation,
      stop: stopApiTrafficValidation,
    },
  };

  return (
    <Provider
      value={{
        isOpen: isOpen === 'open',
        close: () => setIsOpen('closed'),
        open: () => setIsOpen('open'),
        isAnyDevSettingEnabled,
        settings,
      }}
    >
      {props.children}
    </Provider>
  );
}

export {useDeveloperSettings}; // eslint-disable-line react/only-export-components -- Pre-existing violation
